import { useDispatch, useSelector } from "react-redux";

import { uiActions } from "../store/uiReducer";
import HubDialog from "./HubDialog";
import { Alert, Grid } from "@mui/material";

function ErrorDialog() {
  const errorMessages = useSelector((state) => state.ui.errorMessages);

  const dispatch = useDispatch();

  const resetErrors = () => {
    dispatch(uiActions.setErrors());
  };

  return (
    <HubDialog
      open={!!errorMessages}
      onClose={resetErrors}
      actions={{ buttons: [{ title: "Close", onClick: resetErrors }] }}
      buttonOnlyClose
    >
      {typeof errorMessages === "object" && (
        <Grid container spacing={1} width="100%">
          {errorMessages.map((err, index) => (
            <Grid size={{xs: 12}} key={index}>
              <Alert severity="error">{err}</Alert>
            </Grid>
          ))}
        </Grid>
      )}

      {typeof errorMessages === "string" && <Alert severity="error">{errorMessages}</Alert>}
    </HubDialog>
  );
}

ErrorDialog.propTypes = {};

export default ErrorDialog;
